import React, { useEffect, useState } from 'react'
import { Grid, makeStyles, Typography, Container, Divider } from '@material-ui/core'
import { useHistory, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import LoadingBeforeViewData from '../../compartidos/LoadingBeforeViewData';
import { fetchConToken } from '../../../helpers/fetch';
import { startAlerta } from '../../../actions/ui/alertas';


const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    marginTop: "1.5rem",
    marginBottom: "1rem"
  },
  container: {
    marginLeft: "auto",
    marginRight: "auto",
    padding: "1rem",
    display: "block",
    borderRadius: 15
  },
  img: {
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1rem",
    width: "50%"
  },
  title: {
    marginRight: "auto",
    marginLeft: "auto",
    marginTop: "0.75rem",
    fontSize: "0.70rem",
    display: "block"
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    padding: 70,
  },
  align: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  alignDatos: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    width: '100%',
    border: '1px solid #ccc',
    borderRadius: '.3em',
    textAlign: 'center',
  },
  textObservaciones: {
    width: '100%',
    border: '1px solid #ccc',
    borderRadius: '.5em',
    //textAlign: 'left',
    padding: '1em',
    wordBreak: 'break-word',
    textAlign: 'justify',
  },
  paragraphSpacing: {
    marginTop: '0em', // Ajusta el espacio entre párrafos según tus preferencias
  },
  textJustified: {
    textAlign: 'justify', // Aplica justificación al texto
  },
}));


const optionsAño = {
  year: 'numeric',
};

const optionsDia = {
  day: '2-digit'
};

const optionsMes = { month: 'long' };



export const ControlCertificadoAtencion = () => {

  const classes = useStyles();
  const history = useHistory()
  const dispatch = useDispatch()

  const [data, setData] = useState(null);


  const { id } = useParams();

  const getDataCertificado = async () => {
    try {
      const result = await fetchConToken(
        `CertificadosAtencion/ConsultaPorId/${id}`,
      );
      const body = await result.json()
      if (result.ok) {
        setData(body[0])
      } else {
        throw body.errores
      }
    } catch (error) {
      console.log("Hubo un error al traer la información del certificado")
      history.push("/auth/login")
      if (error.mensaje) {
        dispatch(startAlerta(error.mensaje, "error"))
      }
    }
  };



  useEffect(() => {
    //dispatch(fetchEspecialidades(true))
    getDataCertificado();

  }, [])

  if (data === null) {
    return <LoadingBeforeViewData />
  }


  // const especialidad = especialidades?.find(
  //     (e) => e.idEspecialidades === data.usuario.idEspecialidad
  // );

  console.log(id)
  return (
    <div className={classes.root}>
      <Container maxWidth="md">
        <Grid container >
          <Grid item xs={12} className={classes.logo}>
          </Grid>
          <Grid item xs={12} style={{ marginTop: '1em' }}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid container>
                <Grid item xs={12} className={classes.align}>
                  <Typography style={{ fontSize: '1.5em', marginTop: 10 }} color="primary">
                    CERTIFICADO DE ATENCÍON
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: '2em' }}>
            <Divider />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Grid
              container
              spacing={2}
              justify="space-evenly"
              alignItems="flex-end"
            >
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Typography variant="body1">
                  {`Buenos Aires ${new Date(data?.fecha).toLocaleString('es', optionsDia)} de ${new Date(data?.fecha).toLocaleString('es', optionsMes)} , de ${new Date(data?.fecha).toLocaleString('es', optionsAño)} -  ${data?.descripcionCentroMedico}`}
                </Typography>
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Typography variant="body1">
                  {`Dejo contancia que el Beneficiario/a N°: ${data?.carnet} Sr./Sra ${data?.apellidoNombre} 
                  ha asistido al servicio de: ${data?.descripcionEspecialidad} con el Dr/a: ${data?.descripcionEfector} en el horario de ${data?.hora}`}
                </Typography>
              </Grid>

              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Typography variant="body1">

                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: '2em' }}>
            <Divider />
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}
